import { render, staticRenderFns } from "./CustomerHeaderDesktop.vue?vue&type=template&id=6fa6980c&scoped=true&"
import script from "./CustomerHeaderDesktop.vue?vue&type=script&lang=js&"
export * from "./CustomerHeaderDesktop.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHeaderDesktop.vue?vue&type=style&index=0&id=6fa6980c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa6980c",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QTabs,QRouteTab} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QTabs,QRouteTab})
